import type { FunctionComponent } from 'react'
import React, { forwardRef } from 'react'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Dropdown } from 'react-bootstrap'
import { BusyButtonLink } from '@ztechapps/webui.button'

export type TableRowActionProps = {
  showQuickActions: boolean
  firstQuickAction: React.ReactNode
  secondQuickAction?: React.ReactNode
  thirdQuickAction?: React.ReactNode
  children?: React.ReactNode
  components?: {
    TableActionButtonsCell?: FunctionComponent<TableActionButtonsCellProps>
  }
}
export const TableRowAction = ({ showQuickActions, firstQuickAction, secondQuickAction, thirdQuickAction, children, components }: TableRowActionProps) => {
  const ActionButtonsCell = components?.TableActionButtonsCell ?? TableActionButtonsCell

  return (
    <ActionButtonsCell>
      <HorizontalStack gap={1} className="justify-content-end">
        <HorizontalStack gap={1} style={{ visibility: showQuickActions ? 'visible' : 'hidden' }}>
          {firstQuickAction}
          {secondQuickAction}
          {thirdQuickAction}
        </HorizontalStack>
        <ShowIf condition={!!children}>
          <Dropdown align="end">
            <Dropdown.Toggle id="more-actions-toggle" as={MoreActionDropdownToggle} />
            <Dropdown.Menu>{children}</Dropdown.Menu>
          </Dropdown>
        </ShowIf>
      </HorizontalStack>
    </ActionButtonsCell>
  )
}

const MoreActionDropdownToggle = forwardRef<any, { onClick: (e: React.MouseEvent) => void }>(({ onClick }, ref) => (
  <div ref={ref}>
    <BusyButtonLink
      icon="ellipsis-v"
      title="Show more actions..."
      onClick={(e) => {
        onClick(e)
      }}
    />
  </div>
))

export type TableActionButtonsCellProps = {
  children: React.ReactNode
}
export const TableActionButtonsCell = ({ children }: { children: React.ReactNode }) => {
  return (
    <td className="text-end " style={{ width: '30px' }}>
      {children}
    </td>
  )
}

